import $ from 'jquery'
import Modernizr from 'modernizr'

SOPHIA.stickyHeaderForTable = function() {
  var windowWidth = $(window).width();

  if (windowWidth > 600) {
    $('.table-container').stickyTableHeader();

    const $stickyContainer = $('.sticky-container');

    if ($stickyContainer.length && !$stickyContainer.hasClass('no-global-sticky')) {
      $('body').addClass('mag-sticky-nav');
    }
  }

  $(window).on('resize', function() {
    if (windowWidth > 600) {
      var $table = $('.table-container');
      var instance = $table.data('stickyTableHeader');

      if (instance && instance.$header) {
        try {
          instance.destroy();
        } catch (e) {
          console.warn('Sticky header destroy failed:', e);
        }
        $table.removeData('stickyTableHeader');
      }

      $table.stickyTableHeader();
    }
  });

  if (Modernizr.touchevents) {
    $(window).on('orientationchange', function() {
      if (windowWidth > 600) {
        $('.table-container').stickyTableHeader();

        if ($('.sticky-container').length) {
          $('body').addClass('mag-sticky-nav');
        }
      }
    });
  }
};
